<template>
  <div class="component-container">
    <el-row class="row" v-for="row in rows" :key="row">
      <el-col :span="span" v-for="col in cols" :key="col">
        <div v-if="isValidItem(row, col)">
          <jt-input
            v-if="isInput(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :value="currentItem(row, col).value"
            :editable="currentItem(row, col).editable"
            :compWidth="currentItem(row, col).compWidth"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :minLength="currentItem(row, col).minLength"
            :maxLength="currentItem(row, col).maxLength"
            :required="currentItem(row, col).required"
            :expression="currentItem(row, col).expression"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            @enter="handleEnter"
            @createTeam="createTeam"
            :ref="generateRef(row, col)"
          />
          <jt-email
            v-if="isEmail(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :editable="currentItem(row, col).editable"
            :value="currentItem(row, col).value"
            :compWidth="currentItem(row, col).compWidth"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            @enter="handleEnter"
            :ref="generateRef(row, col)"
          />
          <jt-phone
            v-if="isPhone(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :value="currentItem(row, col).value"
            :editable="currentItem(row, col).editable"
            :compWidth="currentItem(row, col).compWidth"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            @enter="handleEnter"
            :ref="generateRef(row, col)"
          />
          <jt-date
            v-if="isDate(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :editable="currentItem(row, col).editable"
            :value="currentItem(row, col).value"
            :compWidth="currentItem(row, col).compWidth"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :format="currentItem(row, col).format"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            @enter="handleEnter"
            :ref="generateRef(row, col)"
          />
          <jt-time
            v-if="isTime(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :editable="currentItem(row, col).editable"
            :value="currentItem(row, col).value"
            :compWidth="currentItem(row, col).compWidth"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :format="currentItem(row, col).format"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            @enter="handleEnter"
            :ref="generateRef(row, col)"
          />
          <jt-date-time
            v-if="isDateTime(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :value="currentItem(row, col).value"
            :editable="currentItem(row, col).editable"
            :compWidth="currentItem(row, col).compWidth"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :format="currentItem(row, col).format"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            @enter="handleEnter"
            :ref="generateRef(row, col)"
          />
          <jt-id-card
            v-if="isIdCard(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :editable="currentItem(row, col).editable"
            :value="currentItem(row, col).value"
            :compWidth="currentItem(row, col).compWidth"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            :types="currentItem(row, col).types"
            @datas="(err, data) => handleData(err, row, col, data)"
            @IDCheck="(data) => handleIDCheck(data, row, col)"
            @enter="handleEnter"
            :ref="generateRef(row, col)"
          />
          <jt-id-card-global
            v-if="isIdCardGlobal(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :editable="currentItem(row, col).editable"
            :value="currentItem(row, col).value"
            :compWidth="currentItem(row, col).compWidth"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            @enter="handleEnter"
            :ref="generateRef(row, col)"
          />
          <jt-single-project
            v-if="isSingleProject(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :value="currentItem(row, col).value"
            :editable="currentItem(row, col).editable"
            :compWidth="currentItem(row, col).compWidth"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :minLength="currentItem(row, col).minLength"
            :maxLength="currentItem(row, col).maxLength"
            :suggestions="currentItem(row, col).suggestions"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            @enter="handleEnter"
            :ref="generateRef(row, col)"
          />
          <jt-group-project
            v-if="isGroupProject(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :value="currentItem(row, col).value"
            :compWidth="currentItem(row, col).compWidth"
            :editable="currentItem(row, col).editable"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :minLength="currentItem(row, col).minLength"
            :maxLength="currentItem(row, col).maxLength"
            :suggestions="currentItem(row, col).suggestions"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            @enter="handleEnter"
            :ref="generateRef(row, col)"
          />
          <jtSelect
            v-if="isSelect(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :editable="currentItem(row, col).editable"
            :value="currentItem(row, col).value"
            :tooltip="currentItem(row, col).tooltip"
            :compWidth="currentItem(row, col).compWidth"
            :options="currentItem(row, col).options"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            @enter="handleEnter"
            :ref="generateRef(row, col)"
          />
          <jtImage
            v-if="isImage(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :src="currentItem(row, col).src"
            :thumbnailWidth="currentItem(row, col).thumbnailWidth"
            :editable="currentItem(row, col).editable"
            :tooltip="currentItem(row, col).tooltip"
            :thumbnailHeight="currentItem(row, col).thumbnailHeight"
            :uploadAction="currentItem(row, col).uploadAction"
            :supportTypes="currentItem(row, col).supportTypes"
            :supportSize="currentItem(row, col).supportSize"
            :supportMinWidth="currentItem(row, col).supportMinWidth"
            :supportMaxWidth="currentItem(row, col).supportMaxWidth"
            :supportMinHeight="currentItem(row, col).supportMinHeight"
            :supportMaxHeight="currentItem(row, col).supportMaxHeight"
            :types="currentItem(row, col).types"
            :scaleWH="currentItem(row, col).scaleWH"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @delete="() => handleImageDelete(row, col)"
            @success="
              (response) => handleImageUploadSuccess(row, col, response)
            "
            @change="
              (file, uploadAction, scaleWH) =>
                handleImgchange(file, uploadAction, scaleWH, row, col)
            "
            :ref="generateRef(row, col)"
          />
          <jtMusic
            v-if="isMusic(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :src="currentItem(row, col).src"
            :musicName="currentItem(row, col).musicName"
            :editable="currentItem(row, col).editable"
            :tooltip="currentItem(row, col).tooltip"
            :width="currentItem(row, col).width"
            :height="currentItem(row, col).height"
            :uploadAction="currentItem(row, col).uploadAction"
            :supportTypes="currentItem(row, col).supportTypes"
            :supportSize="currentItem(row, col).supportSize"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @delete="() => handleMusicDelete(row, col)"
            @success="
              (response) => handleMusicUploadSuccess(row, col, response)
            "
            :ref="generateRef(row, col)"
          />
          <jtVideo
            v-if="isVideo(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :src="currentItem(row, col).src"
            :videoName="currentItem(row, col).videoName"
            :editable="currentItem(row, col).editable"
            :tooltip="currentItem(row, col).tooltip"
            :width="currentItem(row, col).width"
            :height="currentItem(row, col).height"
            :uploadAction="currentItem(row, col).uploadAction"
            :supportTypes="currentItem(row, col).supportTypes"
            :supportSize="currentItem(row, col).supportSize"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @delete="() => handleVideoDelete(row, col)"
            @success="
              (response) => handleVideoUploadSuccess(row, col, response)
            "
            :ref="generateRef(row, col)"
          />
          <jtBigVideo
            v-if="isBigVideo(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :src="currentItem(row, col).src"
            :videoName="currentItem(row, col).videoName"
            :editable="currentItem(row, col).editable"
            :tooltip="currentItem(row, col).tooltip"
            :width="currentItem(row, col).width"
            :height="currentItem(row, col).height"
            :uploadAction="currentItem(row, col).uploadAction"
            :supportTypes="currentItem(row, col).supportTypes"
            :supportSize="currentItem(row, col).supportSize"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @delete="() => handleVideoDelete(row, col)"
            @success="
              (response) => handleVideoUploadSuccess(row, col, response)
            "
            :ref="generateRef(row, col)"
          />
          <jtText
            v-if="isHtml(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :value="currentItem(row, col).value"
            :editable="currentItem(row, col).editable"
            :compWidth="currentItem(row, col).compWidth"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :minLength="currentItem(row, col).minLength"
            :maxLength="currentItem(row, col).maxLength"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            @enter="handleEnter"
            :ref="generateRef(row, col)"
          />
          <jt-district
            v-if="isDistrict(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :value="currentItem(row, col).value"
            :editable="currentItem(row, col).editable"
            :compWidth="currentItem(row, col).compWidth"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :minLength="currentItem(row, col).minLength"
            :maxLength="currentItem(row, col).maxLength"
            :required="currentItem(row, col).required"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            :ref="generateRef(row, col)"
          />
          <jt-redirectPage
            v-if="isRedirectPage(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :compWidth="currentItem(row, col).compWidth"
            :required="currentItem(row, col).required"
            :pageName="currentItem(row, col).pageName"
            @datas="(err, data) => handleData(err, row, col, data)"
            :ref="generateRef(row, col)"
          />
          <jt-statusButton
            v-if="isJtStatusButton(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :compWidth="currentItem(row, col).compWidth"
            :required="currentItem(row, col).required"
            :buttonText="currentItem(row, col).buttonText"
            @datas="(err, data) => handleData(err, row, col, data)"
            :ref="generateRef(row, col)"
          />
          <jt-htmlEdit
            v-if="isHtmlEdit(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :value="currentItem(row, col).value"
            :editable="currentItem(row, col).editable"
            :compWidth="currentItem(row, col).compWidth"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :minLength="currentItem(row, col).minLength"
            :maxLength="currentItem(row, col).maxLength"
            :required="currentItem(row, col).required"
            :expression="currentItem(row, col).expression"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            @enter="handleEnter"
            @createTeam="createTeam"
            :ref="generateRef(row, col)"
          />
          <jt-limitText
            v-if="isLimitText(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :value="currentItem(row, col).value"
            :editable="currentItem(row, col).editable"
            :compWidth="currentItem(row, col).compWidth"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :minLength="currentItem(row, col).minLength"
            :maxLength="currentItem(row, col).maxLength"
            :required="currentItem(row, col).required"
            :expression="currentItem(row, col).expression"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            @enter="handleEnter"
            @createTeam="createTeam"
            :ref="generateRef(row, col)"
          />
          <jt-singleSelect
            v-if="isSingleSelect(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :value="currentItem(row, col).value"
            :editable="currentItem(row, col).editable"
            :compWidth="currentItem(row, col).compWidth"
            :placeholder="currentItem(row, col).placeholder"
            :tooltip="currentItem(row, col).tooltip"
            :minLength="currentItem(row, col).minLength"
            :maxLength="currentItem(row, col).maxLength"
            :required="currentItem(row, col).required"
            :expression="currentItem(row, col).expression"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @datas="(err, data) => handleData(err, row, col, data)"
            @enter="handleEnter"
            @createTeam="createTeam"
            :ref="generateRef(row, col)"
          />

          <jtFile
            v-if="isFile(row, col)"
            :label="currentItem(row, col).label"
            :labelWidth="currentItem(row, col).labelWidth"
            :src="currentItem(row, col).src"
            :fileName="currentItem(row, col).fileName"
            :editable="currentItem(row, col).editable"
            :tooltip="currentItem(row, col).tooltip"
            :width="currentItem(row, col).compWidth"
            :maxLength="currentItem(row, col).maxLength"
            :height="currentItem(row, col).height"
            :uploadAction="currentItem(row, col).uploadAction"
            :supportTypes="currentItem(row, col).supportTypes"
            :supportSize="currentItem(row, col).supportSize"
            :required="currentItem(row, col).required"
            :types="currentItem(row, col).types"
            :alwaysEdit="currentItem(row, col).alwaysEdit"
            @delete="() => handleFileDelete(row, col)"
            @success="
              (response) => handleFileUploadSuccess(row, col, response)
            "
            :ref="generateRef(row, col)"
          />
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import _ from 'lodash'

import Formatter from '../../utils/formatter'
import Validator from '../../utils/validator'
import jtInput from '../input'
import jtEmail from '../email'
import jtPhone from '../phone'
import jtDate from '../date'
import jtTime from '../time'
import jtDateTime from '../datetime'
import jtIdCard from '../id-card'
import jtIdCardGlobal from '../id-cardglobal'
import jtSingleProject from '../single-project'
import jtGroupProject from '../group-project'
import jtSelect from '../select'
import jtImage from '../image'
import jtMusic from '../music'
import jtVideo from '../video'
import jtBigVideo from '../bigvideo'
import jtText from '../text'
import jtDistrict from '../district'
import jtStatusButton from '../status-button'
import jtRedirectPage from '../redirect-page'
import jtHtmlEdit from '../html-edit'
import jtLimitText from '../limit-text'
import jtSingleSelect from '../single-select'
import jtFile from '../file'
import PageModel from '../../models/page'
import { tip } from '@/utils/tool'

export default {
  name: 'jtForm',
  components: {
    jtInput,
    jtEmail,
    jtPhone,
    jtDate,
    jtTime,
    jtDateTime,
    jtIdCard,
    jtIdCardGlobal,
    jtSingleProject,
    jtGroupProject,
    jtSelect,
    jtImage,
    jtMusic,
    jtVideo,
    jtBigVideo,
    jtText,
    jtDistrict,
    jtRedirectPage,
    jtHtmlEdit,
    jtStatusButton,
    jtLimitText,
    jtSingleSelect,
    jtFile
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    cols: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    rows() {
      return _.ceil(this.items.length / this.cols)
    },
    span() {
      return _.floor(24 / this.cols)
    },
  },
  data() {
    return {
      fItems: _.map(this.items, Formatter.formatItem),
      enter: false,
    }
  },
  methods: {
    /** 判断是否为有效行号和列号 */
    isValidItem(rawRow, rawCol) {
      const { row, col } = this._adjustRowAndCol(rawRow, rawCol)
      return row * this.cols + col < this.items.length
    },
    /** 判断是否是jtInput组件 */
    isInput(rawRow, rawCol) {
      return Validator.isInputComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtEmail组件 */
    isEmail(rawRow, rawCol) {
      return Validator.isEmailComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtPhone组件 */
    isPhone(rawRow, rawCol) {
      return Validator.isPhoneComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtDate组件 */
    isDate(rawRow, rawCol) {
      return Validator.isDateComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtTime组件 */
    isTime(rawRow, rawCol) {
      return Validator.isTimeComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtDateTime组件 */
    isDateTime(rawRow, rawCol) {
      return Validator.isDateTimeComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtIdCard组件 */
    isIdCard(rawRow, rawCol) {
      return Validator.isIdCardComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtIdCardGlobal组件 */
    isIdCardGlobal(rawRow, rawCol) {
      return Validator.isIdCardGlobalComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtSingleProject组件 */
    isSingleProject(rawRow, rawCol) {
      return Validator.isSingleProjectComponent(
        this.currentItem(rawRow, rawCol)
      )
    },
    /** 判断是否是jtGroupProject组件 */
    isGroupProject(rawRow, rawCol) {
      return Validator.isGroupProjectComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtSelect组件 */
    isSelect(rawRow, rawCol) {
      return Validator.isSelectComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtSelect组件 */
    isGroupSelect(rawRow, rawCol) {
      return Validator.isSelectComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtImage组件 */
    isImage(rawRow, rawCol) {
      return Validator.isImageComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtMusic组件 */
    isMusic(rawRow, rawCol) {
      return Validator.isMusicComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtVideo组件 */
    isVideo(rawRow, rawCol) {
      return Validator.isVideoComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtBigVideo组件 */
    isBigVideo(rawRow, rawCol) {
      return Validator.isBigVideoComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是jtHtml组件 */
    isHtml(rawRow, rawCol) {
      return Validator.isHtmlComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是District组件 */
    isDistrict(rawRow, rawCol) {
      return Validator.isDistrictComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是RedirectPage组件 */
    isRedirectPage(rawRow, rawCol) {
      return Validator.isRedirectPageComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是statusButton组件 */
    isJtStatusButton(rawRow, rawCol) {
      return Validator.isJtStatusButtonComponent(
        this.currentItem(rawRow, rawCol)
      )
    },
    /** 判断是否是HtmlEdit组件 */
    isHtmlEdit(rawRow, rawCol) {
      return Validator.isHtmlEditComponent(this.currentItem(rawRow, rawCol))
    },
    /** 判断是否是isLimitText组件 */
    isLimitText(rawRow, rawCol) {
      return Validator.isLimitTextComponent(this.currentItem(rawRow, rawCol))
    },

    /** 判断是否是isLimitText组件 */
    isSingleSelect(rawRow, rawCol) {
      return Validator.isSingleSelectComponent(this.currentItem(rawRow, rawCol))
    },
     /** 判断是否是isFile组件 */
    isFile(rawRow, rawCol) {
      return Validator.isFileComponent(this.currentItem(rawRow, rawCol))
    },
    /** 当前表单项 */
    currentItem(rawRow, rawCol) {
      const { row, col } = this._adjustRowAndCol(rawRow, rawCol)
      return this.items[row * this.cols + col]
    },
    /** 生成Ref */
    generateRef(rawRow, rawCol) {
      const { row, col } = this._adjustRowAndCol(rawRow, rawCol)
      return `component_${row}_${col}`
    },
    /** 图片上传成功事件处理 */
    handleImageUploadSuccess(rawRow, rawCol, response) {
      const { row, col } = this._adjustRowAndCol(rawRow, rawCol)
      const index = row * this.cols + col

      this.$emit('image-upload-success', index, response)
    },
    /** 图片上传事件处理 */
    handleImgchange(file, uploadAction, scaleWH, rawRow, rawCol) {
      const { row, col } = this._adjustRowAndCol(rawRow, rawCol)
      const index = row * this.cols + col
      this.$emit('image-upload', file, uploadAction, scaleWH, index)
    },
    /** 删除图片事件处理 */
    handleImageDelete(rawRow, rawCol) {
      const { row, col } = this._adjustRowAndCol(rawRow, rawCol)
      const index = row * this.cols + col

      this.$emit('image-delete', index)
    },
    /** 音频上传成功事件处理 */
    handleMusicUploadSuccess(rawRow, rawCol, response) {
      const { row, col } = this._adjustRowAndCol(rawRow, rawCol)
      const index = row * this.cols + col
      this.$emit('music-upload-success', index, response)
    },
    /** 删除音频事件处理 */
    handleMusicDelete(rawRow, rawCol) {
      const { row, col } = this._adjustRowAndCol(rawRow, rawCol)
      const index = row * this.cols + col

      this.$emit('music-delete', index)
    },
    /** 视频上传成功事件处理 */
    handleVideoUploadSuccess(rawRow, rawCol, response) {
      const { row, col } = this._adjustRowAndCol(rawRow, rawCol)
      const index = row * this.cols + col
      this.$emit('video-upload-success', index, response)
    },
    /** 删除视频事件处理 */
    handleVideoDelete(rawRow, rawCol) {
      const { row, col } = this._adjustRowAndCol(rawRow, rawCol)
      const index = row * this.cols + col
      this.$emit('video-delete', index)
    },
    /** 文件上传成功事件处理 */
    handleFileUploadSuccess(rawRow, rawCol, response) {
      const { row, col } = this._adjustRowAndCol(rawRow, rawCol)
      const index = row * this.cols + col
      this.$emit('file-upload-success', index, response)
    },
    /** 删除文件事件处理 */
    handleFileDelete(rawRow, rawCol) {
      const { row, col } = this._adjustRowAndCol(rawRow, rawCol)
      const index = row * this.cols + col

      this.$emit('file-delete', index)
    },
    
    /** 回车事件处理 */
    handleEnter() {
      // this.enter = true
    },

    /** 创建队伍事件处理 */
    createTeam() {
      this.$emit('createTeam')
    },
    /** 数据处理 */
    handleData(err, rawRow, rawCol, data) {
      const { row, col } = this._adjustRowAndCol(rawRow, rawCol)
      const index = row * this.cols + col

      this.$emit('datas', err, index, data, (success) => {
        if (!success) {
          this._focus(rawRow, rawCol)
          // this.enter = false
          return
        }
        // if (this.enter) {
        //   this._goNext(rawRow, rawCol)
        //   this.enter = false
        // }
      })
    },

    /**身份证唯一检测 */
    async handleIDCheck(obj, row, column) {
      const { gameId, teamId, olidCardOld, value } = obj
      let data = await PageModel.IDCheck(gameId, teamId, olidCardOld, value)
      if (data.errNo == 0) {
        this.handleData(null, row, column, value)
      } else {
        tip(data.errMsg)
      }
    },

    /** 焦点跳去下一个组件 */
    _goNext(rawRow, rawCol) {
      const { row, col } = this._adjustRowAndCol(rawRow, rawCol)
      const length = this.items.length
      const index = row * this.cols + col
      for (let i = (index + 1) % length; i !== index; i = (i + 1) % length) {
        if (_.includes(['jtImage', 'jtMusic', 'jtVideo','jtBigVideo','jtFile'], this.items[i].type)) {
          continue
        }

        const newRow = _.floor(i / this.cols)
        const newCol = i % this.cols
        const ref = this.generateRef(newRow + 1, newCol + 1)
        this.$refs[ref][0].focus()
        return
      }
    },
    /** 根据行号和列号给对应组件上焦点 */
    _focus(rawRow, rawCol) {
      const ref = this.generateRef(rawRow, rawCol)
      this.$refs[ref][0].focus()
    },
    /** 调整行号和列号以0开始计数 */
    _adjustRowAndCol(row, col) {
      row = row - 1
      col = col - 1
      return { row, col }
    },
  },
}
</script>
<style lang="stylus" scoped>
.row {
  margin-bottom: 10px;
}

.form-comp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 768px) {
  .row {
    width: 100%;
  }
}
</style>
